import React from 'react';
import { Helmet } from "react-helmet";

const BreadcrumbSchema = ({ breadcrumbs, baseUrl }) => {
  const domain = baseUrl;

  const itemListElement = breadcrumbs.map((bc, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: bc.name,
    item: `${domain}${bc.path}`
  }));

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
